window.VgMap = {
	city: 'Москва',
	myMap: null,
	clusterer: null,
	pointCollection: null,
	id: '',
	placeMark: {
		layout: '',
		preset: 'islands#icon',
		iconColor: '#AF0003',
		iconColorActive: '#FB9600'
	},
	controls: [
		'geolocationControl',
		'searchControl',
		'typeSelector',
		'fullscreenControl',
		'scrollZoom'
	],

	init: function ($map) {
		let id = $map.attr('id'),
			lat = $map.data('lat') || false,
			lon = $map.data('lon') || false,
			points = $map.data('points') || [],
			reset = $map.data('reset') || false,
			controls = $map.data('controls') || [],
			stores = $map.data('stores') || {},
			cluster = $map.data('cluster') || false,
			event = $map.data('event') || false,
			zoom = $map.data('zoom') || 16;

		VgMap.setSizeMap($map);

		for (let i = 0; i < stores.length; i++) {
			points.push(stores[i]);
		}

		if (points.length && (!lat || !lon)) {
			for (let i = 1; i <= points.length; i++) {
				if (('lat' in points[i - 1]) && ('lon' in points[i - 1])) {
					if (i === 1) {
						lat = points[i - 1].lat;
						lon = points[i - 1].lon;
					}
				}
			}
		}

		if (lat && lon) {
			ymaps.ready(init);

			function init() {
				/* Рисуем карту */
				let myMap = VgMap.setMap(id, [lat, lon], zoom);

				/* Отключаем не нужное. Передаем в массив (дата аттрибут), то что не нужно отключать, если нужно отключить всё оставляем пустым */
				VgMap.disabled(myMap, controls);

				/* Добавляем метку */
				if (points.length) {
					if (!cluster) {
						let objects = getObjects(points);
						VgMap.pointCollection = new ymaps.GeoObjectCollection();

						for (let i in objects) {
							VgMap.pointCollection.add(objects[i]);
						}

						VgMap.myMap.geoObjects.add(VgMap.pointCollection);
						VgMap.myMap.setBounds(myMap.geoObjects.getBounds(), {
							checkZoomRange: true,
							zoomMargin: 40
						});
					} else {
						VgMap.clusterer = new ymaps.Clusterer({
							clusterIconLayout: 'default#pieChart',
							clusterIconPieChartRadius: 25,
							clusterIconPieChartCoreRadius: 15,
							clusterIconPieChartStrokeWidth: 3,
							hasBalloon: false,
							clusterHideIconOnBalloonOpen: false,
							geoObjectHideIconOnBalloonOpen: false,
						});

						VgMap.clusterer.add(getObjects(points));
						myMap.geoObjects.add(VgMap.clusterer);
					}
				} else {
					VgMap.setPlaceMark(myMap, [lat, lon]);
				}

				function getObjects(points) {
					let objects = [];

					for (let i in points) {
						objects[i] = VgMap.setPlaceMark(myMap, points[i], true)
					}

					return objects;
				}

				if (window.innerWidth < 1000) {
					myMap.behaviors.get('drag').disable();
				}

				myMap.geoObjects.events.add('click', function (e) {
					if (event && event === 'clickStore') {
						VgMap.clickStore(e, myMap)
					}
				});

				if (event && event === 'clickStore') {
					VgMap.clickStore(null, myMap)
				}
			}
		} else {
			console.error('Coordinates not found');
			return false;
		}
	},

	setMap: function (id, coordinates, zoom) {
		return new ymaps.Map(id, {
			center: coordinates,
			zoom: zoom,
			controls: ['smallMapDefaultSet'],
		}, {
			searchControlProvider: 'yandex#search',
			suppressMapOpenBlock: true,
		});
	},

	setPlaceMark: function (map, point, obj = false) {
		let placeMark, marker;

		if (VgMap.placeMark.layout) {
			let circleLayout = ymaps.templateLayoutFactory.createClass(VgMap.placeMark.layout);

			marker = {
				iconLayout: circleLayout
			}
		} else {
			marker = {
				preset: VgMap.placeMark.preset,
				iconColor: VgMap.placeMark.iconColor
			}
		}

		let ballon = {
			'langlon': [point.lat, point.lon],
			balloonContent: VgMap.setBalloon(point)
		}

		if (obj) {
			placeMark = new ymaps.Placemark([point.lat, point.lon], ballon, marker);
		} else {
			placeMark = new ymaps.Placemark(
				map.getCenter(), ballon, marker
			);

			map.geoObjects.add(placeMark);
		}

		return placeMark;
	},

	setBalloon: function(mark) {
		let title = mark.title,
			address = mark.address,
			phones = mark.phones;

		if (!title && !address && !phones) return false;

		let phone = (phones.toString().indexOf(',') !== -1) ? phones.split(',') : phones;
		let str_phone = '';

		for (let i = 0; i <= phone.length; i++) {
			if (phone[i] && phone[i] !== 'undefined') {
				str_phone += '<a href="tel:' + phone[i] + '">' + phone[i] + '</a>';
			}
		}

		str_phone = str_phone ? '<div class="phone"><i class="fal fa-phone"></i> ' + str_phone : '';

		return '<div class="map-balloon">' +
			'<div class="description">' +
			'<h4>' + title + '</h4>' +
			'<div class="address"><i class="fal fa-home"></i> ' + address + '</div>' + str_phone +
			'</div>' +
			'<div class="clearfix"></div>' +
			'</div>'
			;
	},

	disabled: function (map, items = []) {
		if (items.length > 0) {
			$.each(items, function (i, val) {
				if (VgMap.controls.indexOf(val) > -1) {
					delete VgMap.controls[i];
				}
			});
		}

		$.each(VgMap.controls, function (i, val) {
			if (val !== 'undefined') {
				map.controls.remove(val);
			}
		});
	},

	setSizeMap: function ($map) {
		if ($map.height() === 0) {
			let hParent = $map.parent().height();

			if (hParent === 0) {
				hParent = $map.parent().parent().height();

				$map.css('height', hParent);
			}
		}

		return false;
	},

	clickStore: function (event = null, myMap) {
		if (event) {
			let target = event.get('target'),
				type = event.get('type'),
				coordinates = target.geometry._coordinates;

			if (type === 'click') {
				let objs = VgMap.clusterer.getGeoObjects();

				for(let el of objs) {
					el.options.set('iconColor', VgMap.placeMark.iconColor);
				}

				target.options.set('iconColor', VgMap.placeMark.iconColorActive);
			}

			myMap.setCenter(coordinates, 16);

			let $addresses = $('[data-all-store]').find('[data-toggle="map-stores"]');
			$addresses.closest('li').removeClass('active');

			for (let i = 0; i < $addresses.length; i++) {
				let address = $addresses[i].dataset.coordinates;

				if (address === coordinates.join(',')) {
					$addresses[i].closest('li').classList.add('active');
				}
			}
		} else {
			$('[data-toggle="map-stores"]').click(function () {
				let address = $(this).data('coordinates'),
					key = $(this).data('key');

				$(this).closest('.stores-list').find('li.active').removeClass('active');
				$(this).closest('li').addClass('active');

				if (address) {
					let p = address.split(','),
						objs = VgMap.clusterer.getGeoObjects(),
						i = 0;

					for(let el of objs) {
						el.options.set('iconColor', VgMap.placeMark.iconColor);

						if (i === key) el.options.set('iconColor', VgMap.placeMark.iconColorActive);
						i++;
					}

					myMap.setCenter(p, 17);
				}

				return false;
			});
		}
	},
};

$(document).ready(function () {
	let $map = $('[data-map]');

	if ($map.length) {
		$map.each(function () {
			VgMap.init($(this));
		});
	}
});